import React from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

export interface ISlideState {
  slidePosition: number
  activeSlide: number
}
export interface IBullet {
  length: number
  slideLength: number
  slideState: ISlideState
  setSlide: (value: number) => void
}

const Bullets = ({ length, slideLength, slideState, setSlide }: IBullet) => {
  const theme = useTheme()

  const styles = {
    bulletContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    sliderBullet: {
      position: 'relative',
      padding: '10px',
      borderRadius: '50px',
      cursor: 'pointer',
      transition: 'all 300ms ease',
      '& span': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
        display: 'block',
        backgroundColor: theme.palette.grey[200],
        width: '12px',
        height: '12px',
        borderRadius: '50px',
        transition: 'all 300ms ease',
      },

      '&:first-child': {
        marginLeft: 0,
      },
      '&:last-child': {
        marginRight: 0,
      },
    },
    activeBullet: {
      '& span': {
        backgroundColor: theme.palette.info.main,
        width: '12px',
        height: '12px',
      },
    },
  }

  return (
    <Box sx={styles.bulletContainer}>
      {Array.from(Array(length - (slideLength - 1))).map((_bullet, i) => {
        return (
          <Box
            key={i}
            id={`carousel-bullet-${i}`}
            role="button"
            aria-label={`Knap til slide ${i + 1}`}
            sx={[styles.sliderBullet, slideState.activeSlide === i ? styles.activeBullet : {}]}
            onClick={() => setSlide(i)}
          >
            <span></span>
          </Box>
        )
      })}
    </Box>
  )
}

export default Bullets
